import { ComponentEventProperties, GENERAL_EVENT_CATEGORY, trackEvent } from "./amplitude";

import { storeApi } from "store/index";

export const onTitleChanged = (
  modelName: keyof typeof storeApi,
  modelId: string,
  newTitle: string,
  { eventName, eventProperties }: ComponentEventProperties = {},
) => {
  storeApi[modelName].partial_update({ id: modelId, title: newTitle });

  if (eventName) {
    trackEvent(eventName, { ...GENERAL_EVENT_CATEGORY, ...eventProperties });
  }
};
